/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_Not_SentInputs */

const vi_einvoice_tax_not_sent = /** @type {(inputs: Einvoice_Tax_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa gửi dữ liệu đến cơ quan thuế`)
};

/**

* @param {Einvoice_Tax_Not_SentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_not_sent = /** @type {((inputs?: Einvoice_Tax_Not_SentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_Not_SentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_not_sent(inputs)
});